import {Inject, Injectable, LOCALE_ID, Optional, PLATFORM_ID} from '@angular/core';
import {LANG} from "../tokens/lang.token";
import {isPlatformBrowser, isPlatformServer} from "@angular/common";
import {platformBrowser} from "@angular/platform-browser";
import {platformServer} from "@angular/platform-server";
import {HttpClient} from "@angular/common/http";
import {WP_REST_API_Language} from "../models/Wordpress/WP_REST_API_Language";
import {WordpressService} from "./wordpress.service";
import {ApiService} from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  current: string;
  locale_id: string;


  constructor(
    @Optional() @Inject(LANG) public lang: string,
    @Optional() @Inject(LOCALE_ID) public locale: string,
    @Inject(PLATFORM_ID) public platformId: Object,
    public http: HttpClient,
    //public apiService: ApiService,
  ) {
    this.current = lang;
    this.locale_id = locale;
    if(!this.current && isPlatformBrowser(platformId)){
      this.current = "fr";
      this.locale_id = "fr-FR";
      const hostname = location.hostname;
      if (hostname.includes('visitvar.com') || hostname.includes('en.visitvar')) {
        this.current = 'en';
        this.locale_id = 'en-GB';
      }
    }
  }

}
